import { knowledgeBaseConstants } from '@constants/knowledge-base';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { knowledgeBaseService } from '@services';

const get = (params, page = 0, pageSize = DEFAULT_PAGE_SIZE) => {
    return dispatch => {
        dispatch(request({ params, page, pageSize }));
        knowledgeBaseService.getKnowledgeBase(params, page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

const refresh = () => {
    return (dispatch, getState) => {
        const { query } = getState().knowledgeBase;
        if (!query) return Promise.resolve();
        return knowledgeBaseService.getKnowledgeBase(query.params, query.page, query.pageSize).then(
            data => {
                if (getState().knowledgeBase.query === query) dispatch(success(data));
            },
            () => {},
        );
    };
};

function request(query) {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_REQUEST, query };
}

function success(data) {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_SUCCESS, data };
}

function failure() {
    return { type: knowledgeBaseConstants.KNOWLEDGE_BASE_FAILURE };
}

export const knowledgeBaseActions = {
    get,
    refresh,
};
